import React, { useState } from 'react';
import { styled } from '@stitches/react';
import { useTranslation } from 'react-i18next';
// import { Link } from 'react-router-dom'; // 暂时未使用

// 页面容器样式
const PageContainer = styled('div', {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '3rem'
});

// 标题容器样式
const TitleSection = styled('section', {
  textAlign: 'center',
  marginBottom: '2rem'
});

// 标题样式
const Title = styled('h1', {
  fontSize: '2.5rem',
  fontWeight: 'bold',
  marginBottom: '1rem',
  color: '$textPrimary'
});

// 副标题样式
const Subtitle = styled('p', {
  fontSize: '1.2rem',
  maxWidth: '800px',
  margin: '0 auto',
  color: '$textSecondary',
  lineHeight: 1.6
});

// 选项卡容器样式
const TabContainer = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  gap: '1rem',
  marginBottom: '2rem',
  flexWrap: 'wrap'
});

// 选项卡按钮样式
const TabButton = styled('button', {
  padding: '0.75rem 1.5rem',
  border: 'none',
  borderRadius: '8px',
  fontWeight: 'medium',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  backgroundColor: '$backgroundSecondary',
  color: '$textPrimary',
  '&:hover': {
    backgroundColor: '$backgroundHover'
  },
  variants: {
    active: {
      true: {
        backgroundColor: '$accentPrimary',
        color: 'white'
      }
    }
  }
});

// 集合介绍容器样式
const CollectionIntro = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '1.5rem',
  marginBottom: '3rem',
  padding: '2rem',
  background: '$backgroundSecondary',
  borderRadius: '12px'
});

// 集合标题样式
const CollectionTitle = styled('h2', {
  fontSize: '2rem',
  fontWeight: 'bold',
  color: '$textPrimary'
});

// 集合描述样式
const CollectionDescription = styled('p', {
  fontSize: '1.1rem',
  color: '$textSecondary',
  lineHeight: 1.6,
  maxWidth: '800px'
});

// 集合信息块容器样式
const CollectionInfoBlocks = styled('div', {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
  gap: '1.5rem',
  marginTop: '1rem'
});

// 集合信息块样式
const InfoBlock = styled('div', {
  padding: '1.5rem',
  borderRadius: '8px',
  background: '$backgroundPrimary',
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem'
});

// 信息块标题样式
const InfoBlockTitle = styled('h3', {
  fontSize: '1.1rem',
  fontWeight: 'bold',
  color: '$textPrimary'
});

// 信息块内容样式已删除 - 当前未使用

// 信息块值样式
const InfoBlockValue = styled('span', {
  fontSize: '1.5rem',
  fontWeight: 'bold',
  color: '$accentPrimary'
});

// NFT卡片网格容器样式
const NftGrid = styled('div', {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
  gap: '2rem'
});

// NFT卡片样式
const NftCard = styled('div', {
  background: '$backgroundSecondary',
  borderRadius: '12px',
  overflow: 'hidden',
  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  
  '&:hover': {
    transform: 'translateY(-5px)',
    boxShadow: '0 10px 20px rgba(0, 0, 0, 0.1)'
  }
});

// NFT图片容器样式
const NftImageContainer = styled('div', {
  width: '100%',
  height: '280px',
  position: 'relative'
});

// NFT图片样式
const NftImage = styled('div', {
  width: '100%',
  height: '100%',
  background: 'center/cover no-repeat',
  transition: 'transform 0.5s ease',
  
  '&:hover': {
    transform: 'scale(1.05)'
  }
});

// NFT稀有度标签样式
const RarityBadge = styled('span', {
  position: 'absolute',
  top: '10px',
  right: '10px',
  padding: '0.25rem 0.75rem',
  borderRadius: '20px',
  fontSize: '0.8rem',
  fontWeight: 'bold',
  zIndex: 1,
  
  variants: {
    rarity: {
      common: {
        background: '#6c757d',
        color: 'white'
      },
      uncommon: {
        background: '#28a745',
        color: 'white'
      },
      rare: {
        background: '#007bff',
        color: 'white'
      },
      epic: {
        background: '#6f42c1',
        color: 'white'
      },
      legendary: {
        background: '#ff9800',
        color: 'white'
      }
    }
  }
});

// NFT内容容器样式
const NftContent = styled('div', {
  padding: '1.5rem'
});

// NFT名称样式
const NftName = styled('h3', {
  fontSize: '1.25rem',
  fontWeight: 'bold',
  marginBottom: '0.5rem',
  color: '$textPrimary'
});

// NFT描述样式
const NftDescription = styled('p', {
  fontSize: '0.9rem',
  color: '$textSecondary',
  marginBottom: '1rem',
  lineHeight: 1.5
});

// NFT属性容器样式
const NftAttributes = styled('div', {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '0.75rem',
  marginBottom: '1.5rem'
});

// NFT属性项样式
const AttributeItem = styled('div', {
  display: 'flex',
  flexDirection: 'column'
});

// NFT属性标签样式
const AttributeLabel = styled('span', {
  fontSize: '0.8rem',
  color: '$textTertiary',
  marginBottom: '0.25rem'
});

// NFT属性值样式
const AttributeValue = styled('span', {
  fontSize: '0.9rem',
  fontWeight: 'bold',
  color: '$textPrimary'
});

// 价格和按钮容器样式
const ActionContainer = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: '1rem',
  paddingTop: '1rem',
  borderTop: '1px solid $borderColor'
});

// 价格容器样式
const PriceContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column'
});

// 价格标签样式
const PriceLabel = styled('span', {
  fontSize: '0.8rem',
  color: '$textTertiary'
});

// 价格值样式
const PriceValue = styled('span', {
  fontSize: '1.25rem',
  fontWeight: 'bold',
  color: '$accentPrimary'
});

// 按钮样式
const Button = styled('button', {
  padding: '0.75rem 1.5rem',
  fontSize: '0.9rem',
  fontWeight: 'bold',
  borderRadius: '8px',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  
  variants: {
    variant: {
      primary: {
        background: '$accentPrimary',
        color: 'white',
        border: 'none',
        '&:hover': {
          opacity: 0.9
        }
      },
      secondary: {
        background: 'transparent',
        color: '$accentPrimary',
        border: '1px solid $accentPrimary',
        '&:hover': {
          background: 'rgba(6, 214, 160, 0.05)'
        }
      }
    }
  },
  
  defaultVariants: {
    variant: 'primary'
  }
});

/**
 * NFT矿场收藏品页面组件
 * 展示NFT挖矿收藏品系列
 */
const NftFarmCollections: React.FC = () => {
  const { t } = useTranslation();
  // 选择当前集合
  const [selectedCollection, setSelectedCollection] = useState<string>('miners');
  
  // 处理选项卡点击
  const handleTabClick = (collection: string) => {
    setSelectedCollection(collection);
  };
  
  // 集合数据
  const collections = {
    miners: {
      title: t('nftFarm.collections.miners.title', '矿工系列'),
      description: t('nftFarm.collections.miners.description', '矿工系列NFT代表虚拟矿机，每个NFT都有独特的挖矿属性和视觉设计。持有者可以获得基于NFT属性的每日挖矿收益。'),
      info: [
        {
          title: t('nftFarm.collections.totalSupply', '总供应量'),
          value: '10,000'
        },
        {
          title: t('nftFarm.collections.floorPrice', '最低价格'),
          value: '0.5 ETH'
        },
        {
          title: t('nftFarm.collections.maxHashrate', '最高算力'),
          value: '0.015 BTC/天'
        },
        {
          title: t('nftFarm.collections.holders', '持有者数量'),
          value: '3,752'
        }
      ],
      items: [
        {
          id: 1,
          name: 'Golden Miner #042',
          description: '金色矿工是稀有的高级挖矿NFT，提供优质的挖矿收益和额外奖励机会。',
          image: '/assets/nft-golden-miner.jpg',
          rarity: 'legendary',
          attributes: {
            hashrate: '0.005 BTC/日',
            boost: '+15%',
            luck: '高',
            durability: '98/100'
          },
          price: '2.5 ETH'
        },
        {
          id: 2,
          name: 'Diamond Driller #137',
          description: '钻石钻探者拥有顶级的挖矿效率和稀有的视觉外观，是高级收藏家的首选。',
          image: '/assets/nft-diamond-driller.jpg',
          rarity: 'epic',
          attributes: {
            hashrate: '0.008 BTC/日',
            boost: '+12%',
            luck: '中高',
            durability: '95/100'
          },
          price: '1.8 ETH'
        },
        {
          id: 3,
          name: 'Quantum Digger #089',
          description: '量子挖掘者采用先进的量子技术，提供稳定的挖矿收益和不错的属性加成。',
          image: '/assets/nft-quantum-digger.jpg',
          rarity: 'rare',
          attributes: {
            hashrate: '0.004 BTC/日',
            boost: '+8%',
            luck: '中',
            durability: '92/100'
          },
          price: '1.2 ETH'
        },
        {
          id: 4,
          name: 'Copper Miner #251',
          description: '铜矿工是入门级挖矿NFT，适合新手收藏者开始NFT挖矿之旅。',
          image: '/assets/nft-copper-miner.jpg',
          rarity: 'uncommon',
          attributes: {
            hashrate: '0.002 BTC/日',
            boost: '+5%',
            luck: '低',
            durability: '90/100'
          },
          price: '0.6 ETH'
        },
        {
          id: 5,
          name: 'Iron Excavator #394',
          description: '铁挖掘者提供基础的挖矿能力，是普通级别的挖矿NFT。',
          image: '/assets/nft-iron-excavator.jpg',
          rarity: 'common',
          attributes: {
            hashrate: '0.001 BTC/日',
            boost: '+3%',
            luck: '很低',
            durability: '85/100'
          },
          price: '0.3 ETH'
        },
        {
          id: 6,
          name: 'Stellar Excavator #251',
          description: '星际挖掘者是一款设计独特的太空主题挖矿NFT，拥有不错的稀有度和收益率。',
          image: '/assets/nft-stellar-excavator.jpg',
          rarity: 'epic',
          attributes: {
            hashrate: '0.007 BTC/日',
            boost: '+10%',
            luck: '中高',
            durability: '93/100'
          },
          price: '1.6 ETH'
        }
      ]
    },
    lands: {
      title: t('nftFarm.collections.lands.title', '矿区土地'),
      description: t('nftFarm.collections.lands.description', '矿区土地NFT代表虚拟采矿土地，提供额外的算力提升和特殊奖励。矿工NFT可以部署在土地上获得收益加成。'),
      info: [
        {
          title: t('nftFarm.collections.totalSupply', '总供应量'),
          value: '5,000'
        },
        {
          title: t('nftFarm.collections.floorPrice', '最低价格'),
          value: '0.8 ETH'
        },
        {
          title: t('nftFarm.collections.maxBoost', '最高提升'),
          value: '+30%'
        },
        {
          title: t('nftFarm.collections.holders', '持有者数量'),
          value: '2,143'
        }
      ],
      items: [
        {
          id: 1,
          name: 'Gold Land #028',
          description: '黄金矿区是稀有的采矿土地，为部署的矿工提供显著的算力提升。',
          image: '/assets/nft-gold-land.jpg',
          rarity: 'legendary',
          attributes: {
            boost: '+30%',
            slots: '5个矿工',
            resources: '金、银、铜',
            respawn: '24小时'
          },
          price: '3.2 ETH'
        },
        {
          id: 2,
          name: 'Crystal Cave #094',
          description: '水晶洞穴是一种特殊的矿区，可以发现稀有矿石和宝石，提供特殊奖励机会。',
          image: '/assets/nft-crystal-cave.jpg',
          rarity: 'epic',
          attributes: {
            boost: '+25%',
            slots: '4个矿工',
            resources: '水晶、宝石',
            respawn: '36小时'
          },
          price: '2.5 ETH'
        },
        {
          id: 3,
          name: 'Mountain Range #112',
          description: '山脉区域拥有丰富的矿物资源，是中等稀有度的矿区土地。',
          image: '/assets/nft-mountain-range.jpg',
          rarity: 'rare',
          attributes: {
            boost: '+15%',
            slots: '3个矿工',
            resources: '铁、煤、银',
            respawn: '12小时'
          },
          price: '1.4 ETH'
        },
        {
          id: 4,
          name: 'Forest Mine #275',
          description: '森林矿区是隐藏在森林中的矿产资源点，提供不错的资源和收益。',
          image: '/assets/nft-forest-mine.jpg',
          rarity: 'uncommon',
          attributes: {
            boost: '+10%',
            slots: '2个矿工',
            resources: '铁、铜',
            respawn: '8小时'
          },
          price: '0.9 ETH'
        }
      ]
    },
    tools: {
      title: t('nftFarm.collections.tools.title', '挖矿工具'),
      description: t('nftFarm.collections.tools.description', '挖矿工具NFT可以装备在矿工NFT上，提供额外的属性加成和特殊能力，提升挖矿效率和收益。'),
      info: [
        {
          title: t('nftFarm.collections.totalSupply', '总供应量'),
          value: '20,000'
        },
        {
          title: t('nftFarm.collections.floorPrice', '最低价格'),
          value: '0.2 ETH'
        },
        {
          title: t('nftFarm.collections.maxBoost', '最高提升'),
          value: '+25%'
        },
        {
          title: t('nftFarm.collections.holders', '持有者数量'),
          value: '4,825'
        }
      ],
      items: [
        {
          id: 1,
          name: 'Quantum Pickaxe #067',
          description: '量子镐是最高级的挖矿工具，使用量子技术大幅提升挖矿效率。',
          image: '/assets/nft-quantum-pickaxe.jpg',
          rarity: 'legendary',
          attributes: {
            boost: '+25%',
            durability: '200/200',
            special: '几率双倍产出',
            compatibility: '所有矿工'
          },
          price: '1.8 ETH'
        },
        {
          id: 2,
          name: 'Diamond Drill #143',
          description: '钻石钻头提供优秀的挖矿加成，使用寿命长且性能稳定。',
          image: '/assets/nft-diamond-drill.jpg',
          rarity: 'epic',
          attributes: {
            boost: '+20%',
            durability: '150/150',
            special: '减少能源消耗',
            compatibility: '机械型矿工'
          },
          price: '1.2 ETH'
        },
        {
          id: 3,
          name: 'Energy Gauntlet #218',
          description: '能量手套使用特殊能源技术，提供中等的挖矿效率提升。',
          image: '/assets/nft-energy-gauntlet.jpg',
          rarity: 'rare',
          attributes: {
            boost: '+15%',
            durability: '120/120',
            special: '提高稀有资源发现率',
            compatibility: '人形矿工'
          },
          price: '0.8 ETH'
        },
        {
          id: 4,
          name: 'Steel Hammer #362',
          description: '钢锤是耐用的基础挖矿工具，提供稳定的小幅度效率提升。',
          image: '/assets/nft-steel-hammer.jpg',
          rarity: 'uncommon',
          attributes: {
            boost: '+10%',
            durability: '100/100',
            special: '无',
            compatibility: '所有矿工'
          },
          price: '0.4 ETH'
        },
        {
          id: 5,
          name: 'Iron Shovel #485',
          description: '铁铲是最基础的挖矿工具，适合初学者使用。',
          image: '/assets/nft-iron-shovel.jpg',
          rarity: 'common',
          attributes: {
            boost: '+5%',
            durability: '80/80',
            special: '无',
            compatibility: '所有矿工'
          },
          price: '0.2 ETH'
        }
      ]
    }
  };
  
  // 获取当前选中的集合
  const currentCollection = collections[selectedCollection as keyof typeof collections];
  
  // 渲染稀有度标签
  const renderRarityBadge = (rarity: string) => {
    const rarityMap: {[key: string]: string} = {
      common: t('nftFarm.rarities.common', '普通'),
      uncommon: t('nftFarm.rarities.uncommon', '不普通'),
      rare: t('nftFarm.rarities.rare', '稀有'),
      epic: t('nftFarm.rarities.epic', '史诗'),
      legendary: t('nftFarm.rarities.legendary', '传说')
    };
    
    return (
      <RarityBadge rarity={rarity as any}>
        {rarityMap[rarity] || rarity}
      </RarityBadge>
    );
  };
  
  return (
    <PageContainer>
      <TitleSection>
        <Title>{t('nftFarm.collections.title', 'NFT挖矿收藏品')}</Title>
        <Subtitle>{t('nftFarm.collections.subtitle', '探索我们独特的NFT收藏品系列，每个NFT都能提供不同的挖矿能力和收益')}</Subtitle>
      </TitleSection>
      
      <TabContainer>
        <TabButton
          active={selectedCollection === 'miners'}
          onClick={() => handleTabClick('miners')}
        >
          {t('nftFarm.collections.miners.tabName', '矿工系列')}
        </TabButton>
        <TabButton
          active={selectedCollection === 'lands'}
          onClick={() => handleTabClick('lands')}
        >
          {t('nftFarm.collections.lands.tabName', '矿区土地')}
        </TabButton>
        <TabButton
          active={selectedCollection === 'tools'}
          onClick={() => handleTabClick('tools')}
        >
          {t('nftFarm.collections.tools.tabName', '挖矿工具')}
        </TabButton>
      </TabContainer>
      
      <CollectionIntro>
        <CollectionTitle>{currentCollection.title}</CollectionTitle>
        <CollectionDescription>{currentCollection.description}</CollectionDescription>
        
        <CollectionInfoBlocks>
          {currentCollection.info.map((info, index) => (
            <InfoBlock key={index}>
              <InfoBlockTitle>{info.title}</InfoBlockTitle>
              <InfoBlockValue>{info.value}</InfoBlockValue>
            </InfoBlock>
          ))}
        </CollectionInfoBlocks>
      </CollectionIntro>
      
      <NftGrid>
        {currentCollection.items.map(nft => (
          <NftCard key={nft.id}>
            <NftImageContainer>
              <NftImage style={{ background: `url(${nft.image || '/assets/nft-placeholder.jpg'}) center/cover no-repeat` }} />
              {nft.rarity && renderRarityBadge(nft.rarity)}
            </NftImageContainer>
            
            <NftContent>
              <NftName>{nft.name}</NftName>
              <NftDescription>{nft.description}</NftDescription>
              
              <NftAttributes>
                {Object.entries(nft.attributes).map(([key, value], index) => (
                  <AttributeItem key={index}>
                    <AttributeLabel>{t(`nftFarm.attributes.${key}`, key)}</AttributeLabel>
                    <AttributeValue>{value}</AttributeValue>
                  </AttributeItem>
                ))}
              </NftAttributes>
              
              <ActionContainer>
                <PriceContainer>
                  <PriceLabel>{t('nftFarm.price', '价格')}</PriceLabel>
                  <PriceValue>{nft.price}</PriceValue>
                </PriceContainer>
                
                <Button variant="primary">
                  {t('nftFarm.buyNFT', '购买NFT')}
                </Button>
              </ActionContainer>
            </NftContent>
          </NftCard>
        ))}
      </NftGrid>
    </PageContainer>
  );
};

export default NftFarmCollections; 